/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BillingInvoices_stateTypes$ref: FragmentReference;
declare export opaque type BillingInvoices_stateTypes$fragmentType: BillingInvoices_stateTypes$ref;
export type BillingInvoices_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: BillingInvoices_stateTypes$ref,
|};
export type BillingInvoices_stateTypes$data = BillingInvoices_stateTypes;
export type BillingInvoices_stateTypes$key = {
  +$data?: BillingInvoices_stateTypes$data,
  +$fragmentRefs: BillingInvoices_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BillingInvoices_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'dc8f09a96b2a788f1f2a8d7772be7afd';
module.exports = node;
